import { render, staticRenderFns } from "./OfferElement.vue?vue&type=template&id=f9483556"
import script from "./OfferElement.vue?vue&type=script&lang=js"
export * from "./OfferElement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports